import { Stack,TableCell,TableBody,TableRow} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
// import LoadingImage from "../../Assets/loading_icon.gif.mp4";

export default function LoadingPage({colSpan}) {
  // return (
  //   <Stack direction="column" justifyContent="center" height="300px" bgcolor="white" width="100%">
  //     <Stack direction="row" justifyContent="center">
  //       <CircularProgress color="primary"/> 
  //     </Stack>
  //   </Stack>
  // );
  return (
    <>
    { colSpan ?
    <TableBody className="body">
    <TableRow className="body-row">
      <TableCell colSpan={colSpan} className="body-cell">
      <Stack direction="column" justifyContent="center" height="300px" bgcolor="white" width="100%">
      <Stack direction="row" justifyContent="center">
        <CircularProgress color="primary"/> 
      </Stack>
    </Stack>
      </TableCell>
    </TableRow>
  </TableBody>
  :<Stack direction="column" justifyContent="center" height="300px" bgcolor="white" width="100%">
  <Stack direction="row" justifyContent="center">
    <CircularProgress color="primary"/> 
  </Stack>
</Stack>
  }
  </>
  );
}
